<template>
  <div>
    <section class="section title-background">
      <div class="container">
        <div class="columns">
          <div class="column">
            <div class="m-2">
              <h2 class="title is-size-2">CONTACTO</h2>
            </div>
          </div>
        </div>
      </div>
    </section>

     <section class="section">
      <div class="container">
        <h4 class="title is-size-1 is-spaced">Contáctanos</h4>

        <div class="columns mt-01">

          <div class="column is-7">
            <form @submit.prevent="submit">
              <div class="notification is-primary" v-if="success">
                <button class="delete" @click="success=false"></button>
                Pronto nos pondremos en contacto contigo.
              </div>
              <div class="notification is-danger" v-if="errors">
                <button class="delete" @click="errors=false"></button>
                Error no podemos procesar tu petición en estos momentos intenta de nuevo.
              </div>
              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Nombre</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input class="input" type="text" v-model="name_contact" name="name_contact" placeholder="">
                    </div>
                  </div>
                </div>
              </div>

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Email</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input class="input" type="email" v-model="email_contact" name="email_contact" placeholder="">
                    </div>
                  </div>
                </div>
              </div>

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Mensaje</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <textarea class="textarea" v-model="message_contact" name="message_contact"></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <div class="field is-horizontal">
                <div class="field-label is-normal">
                  <label class="label">Captcha</label>
                </div>
                <div class="field-body">
                  <div class="field">
                    <vue-recaptcha ref="recaptcha" sitekey="6LeR-1kUAAAAAHCAMWj4mAsNZ9y3du4oBqjumEQl" @verify="onCaptchaVerified" @expired="onCaptchaExpired"></vue-recaptcha>
                  </div>
                </div>
              </div>


              <button :disabled="status==='submitting'" class="button is-danger is-large">Enviar</button>
            </form>

          </div>

          <div class="column is-5">
            <div class="video-container">
              <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14882.845170995924!2d-86.8295708!3d21.1638848!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xeb33b59c4dbe4cf6!2sSindicato+de+la+CROC%2C+Cancun!5e0!3m2!1ses!2smx!4v1539417058179" frameborder="0" style="border:0" allowfullscreen></iframe>
            </div>
          </div>


        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import axios from 'axios';

export default {
  name: 'Contacto',
  data () {
    return {
       status: "",
       email_contact:"",
       message_contact:"",
       name_contact:"",
       success:false,
       errors:false,
    }
  },
  computed: {
  },
  components: {
    VueRecaptcha,
  },
  mounted() {

  },
  methods:{
    submit: function () {
      this.$refs.recaptcha.execute();
    },
    onCaptchaVerified: function (recaptchaToken) {
      const self = this;
      self.status = "submitting";
      self.$refs.recaptcha.reset();
      axios.post(process.env.API_URL_V1+'contact?api_token='+process.env.API_TOKEN_V1, {
        type_web:'mariomachuca',
        email_contact: self.email_contact,
        name_contact:self.name_contact,
        message_contact:self.message_contact,
        recaptchaToken: recaptchaToken,
      }).then((response) => {
        self.success = true;
        self.status = '';
      }).catch((err) => {
       self.errors = true;
       self.status = '';
     });

    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset();
    }
  },
  created :function(){

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Contacto.vue